module.exports = __webpack_public_path__ + "img/Arrrr.fccf45c8.svg";